import { create } from "zustand";
import { persist } from "zustand/middleware";

interface TemporaryChatStore {
  // State
  isTemporaryMode: boolean;
  didShowInfoModal: boolean;

  // Actions
  enableTemporaryMode: () => void;
  disableTemporaryMode: () => void;
  setDidShowInfoModal: (enable: boolean) => void;
  // Reset
  reset: () => void;
}

const initialState = {
  isTemporaryMode: false,
  didShowInfoModal: false,
};

export const useTemporaryChatStore = create<TemporaryChatStore>()(
  persist(
    (set) => ({
      ...initialState,

      // Actions
      enableTemporaryMode: () => set({ isTemporaryMode: true }),
      disableTemporaryMode: () => set({ isTemporaryMode: false }),
      setDidShowInfoModal: (enable: boolean) =>
        set({ didShowInfoModal: enable }),
      // Reset
      reset: () => set(initialState),
    }),
    {
      name: "temporary-chat-storage",
      partialize: () => ({
        // Temporary mode state'i persist etme - her seferinde fresh başlasın
        isTemporaryMode: false,
      }),
    }
  )
);
